import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/iac-pipeline/page.tsx");
